/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_Selected_LowercaseInputs */

const en_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events selected to convert to lowercase.`)
};

const fr_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement sélectionné pour la conversion en minuscules.`)
};

const de_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Ereignisse ausgewählt, die in Kleinbuchstaben umgewandelt werden sollen.`)
};

const it_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato da convertire in minuscolo.`)
};

const ru_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для преобразования в нижний регистр не выбрано ни одного события.`)
};

const es_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos seleccionados para convertir a minúsculas.`)
};

const zh_cn2_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有选择要转换为小写的事件。`)
};

const ja_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小文字に変換するイベントが選択されていません。`)
};

const hi_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोअरकेस में बदलने के लिए कोई इवेंट चयनित नहीं हैं।`)
};

const pt_pt2_no_events_selected_lowercase = /** @type {(inputs: No_Events_Selected_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado para conversão para minúsculas.`)
};

/**
* | output |
* | --- |
* | "No events selected to convert to lowercase." |
*
* @param {No_Events_Selected_LowercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_events_selected_lowercase = /** @type {((inputs?: No_Events_Selected_LowercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_Selected_LowercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_events_selected_lowercase(inputs)
	if (locale === "de") return de_no_events_selected_lowercase(inputs)
	if (locale === "it") return it_no_events_selected_lowercase(inputs)
	if (locale === "ru") return ru_no_events_selected_lowercase(inputs)
	if (locale === "es") return es_no_events_selected_lowercase(inputs)
	if (locale === "zh-CN") return zh_cn2_no_events_selected_lowercase(inputs)
	if (locale === "ja") return ja_no_events_selected_lowercase(inputs)
	if (locale === "hi") return hi_no_events_selected_lowercase(inputs)
	if (locale === "pt-PT") return pt_pt2_no_events_selected_lowercase(inputs)
	return en_no_events_selected_lowercase(inputs)
});